<div class="grid-container margin-top">
  <ag-grid-angular class="data-grid full-page" [gridOptions]="gridOptions" [rowData]="contacts" aria-label="Manage Contacts"></ag-grid-angular>
</div>
